const getImage = (contentInfo, size) => {
  return (
    contentInfo?.images?.[size] ||
    contentInfo?.[`image_${size}`] ||
    contentInfo?.[`image_base_${size}`] ||
    contentInfo?.image ||
    ''
  );
};

const provider = (contentInfo, data) => {
  return (
    contentInfo?.provider?.[data] || contentInfo?.[`proveedor_${data}`] || ''
  );
};

const IsLive = contentInfo => {
  if (contentInfo?.live_enabled)
    return contentInfo?.live_enabled === '1' || contentInfo?.live_enabled === 1;

  const isCahnnel = contentInfo?.contentType === 'channel';
  const isTypeLive = contentInfo?.contentAttributes?.liveType === '1';
  return isCahnnel && isTypeLive;
};

const NoIsLive = contentInfo => {
  if (contentInfo?.live_enabled)
    return contentInfo?.live_enabled !== '1' || contentInfo?.live_enabled !== 1;

  const isCahnnel = contentInfo?.contentType === 'channel';
  const isTypeLive = contentInfo?.contentAttributes?.liveType === '1';

  if (isCahnnel && isTypeLive) {
    const isCahnnel = contentInfo?.contentType !== 'channel';
    const isTypeLive = contentInfo?.contentAttributes?.liveType !== '1';
    return isCahnnel && isTypeLive;
  }

  return false;
};

export const titleUri = contentInfo => {
  return contentInfo?.title_uri || contentInfo?.title.replace(/ /g, '-') || '';
};

const marketingType = contentInfo => {
  return (
    contentInfo?.contentAttributes?.marketingType ||
    contentInfo?.format_types ||
    ''
  );
};

export const getContentListV1 = {
  provider,
  getImage,
  IsLive,
  NoIsLive,
  titleUri,
  marketingType,
};
